import { type AxiosError, HttpStatusCode } from "axios";

import { useSubmitTaskResult } from "@vega-api/generated/tasks-v1/tasks-v1";
import { useStatusPopup } from "@vega-core/hooks/useStatusPopup";
import { m } from "@vega-core/paraglide/messages";

export const useSubmitTask = () => {
  const { setError } = useStatusPopup();

  const {
    mutate: submitTask,
    isPending,
    ...rest
  } = useSubmitTaskResult({
    mutation: {
      onError: (error: AxiosError) => {
        if (error.response?.status === HttpStatusCode.BadRequest) {
          setError({
            description: m.errors_unexpectedError(),
            title: m.errors_modalTitle(),
          });
        }
      },
    },
  });

  return {
    isPending,
    submitTask,
    ...rest,
  };
};
